<template>

    <b-button class="inline-submenu-btn with_icon" @click="$router.go(-1)">
        <b-icon icon="arrow-left-circle" aria-hidden="true"></b-icon>
        {{ $t("retour") }}</b-button>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>